import React from 'react'
import { Button } from '@mantine/core'
import { StepperModalContent, useStepperContext } from '@/components'
import { type LsmValidatorBlockStatus } from '../../utils'

interface StakeLsmBlockedProps {
  status: LsmValidatorBlockStatus
}

const StakeLsmBlocked: React.FC<StakeLsmBlockedProps> = ({ status }) => {
  const { forceClose } = useStepperContext()

  return (
    <StepperModalContent
      title="Unable to liquid stake"
      description={status.message}
      actions={
        <Button color="dark" onClick={forceClose}>
          Exit
        </Button>
      }
    />
  )
}

export { StakeLsmBlocked }
